module.exports = __webpack_public_path__ + "img/jinniao_icon03.8ef33620.png";